// navigator.onLine 이 true 여도 요청이 닿지 못하는 순간을 판정한다. 화면이 숨겨져 있거나(백그라운드 탭·앱 전환),
// 온라인·화면 복귀 직후 grace 안이면 "불안정" — 잠자기에서 깨어나 와이파이가 다시 붙는 몇 초 사이에 자동 요청
// (SSE 재연결 뒤 알림 조회, 1분 학습 시간 전송)이 ERR_NETWORK 로 실패하는 경우를 환경 탓으로 돌리려고 둔다.

type VisibilityDocument = EventTarget & { visibilityState: DocumentVisibilityState }

export const createNetworkSettleProbe = ({
  win,
  doc,
  now = Date.now,
  graceMs = 10_000,
}: {
  win: EventTarget
  doc: VisibilityDocument
  now?: () => number
  graceMs?: number
}): (() => boolean) => {
  let resumedAt = Number.NEGATIVE_INFINITY

  win.addEventListener('online', () => {
    resumedAt = now()
  })
  doc.addEventListener('visibilitychange', () => {
    if (doc.visibilityState === 'visible') resumedAt = now()
  })

  return () => doc.visibilityState === 'hidden' || now() - resumedAt < graceMs
}
